module.exports = __webpack_public_path__ + "static/media/front_woman.d23545b9.svg";